import { useEffect, useRef } from "react";
import { translateArtifacts } from "../api";

/**
 * Lazily translates issue/task titles + descriptions into the viewer's language.
 * Results are cached in the DB (translations.{lang}) and merged back into local state.
 *
 * @param items    array of issues or tasks
 * @param setItems state setter for the array (must accept an updater function)
 * @param kind     "issue" | "task"
 * @param lang     viewer language ("en" | "pt")
 */
export function useArtifactTranslations(items, setItems, kind, lang) {
  const reqRef = useRef(new Set());
  useEffect(() => {
    if (!items || items.length === 0) return;
    const missing = items.filter((i) =>
      (((i.title || "").trim()) || ((i.description || "").trim())) &&
      !(i.translations && i.translations[lang]) &&
      !reqRef.current.has(i.id + lang));
    if (missing.length === 0) return;
    missing.forEach((i) => reqRef.current.add(i.id + lang));
    const ids = missing.map((i) => i.id);
    translateArtifacts(kind === "issue" ? ids : [], kind === "task" ? ids : [], lang)
      .then((res) => {
        const map = (kind === "issue" ? res?.issues : res?.tasks) || {};
        if (Object.keys(map).length === 0) return;
        setItems((prev) => prev.map((i) => (
          map[i.id] ? { ...i, translations: { ...(i.translations || {}), [lang]: map[i.id] } } : i
        )));
      })
      .catch(() => {});
  }, [items, setItems, kind, lang]);
}
